



















































import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    pageDataType,
    InvestPageDataType,
    componentDataType
} from "../types";
import {
    HOST,
    API_URL
} from "../global";
import {
    FETCH_INVEST_DATA
} from "../store/actions.names";
import {
    SET_INVEST_CURRENT_PAGE,
    SET_INVEST_DATA,
    CURRENT_PAGE_ERROR,
    SET_INVEST_PARENT_PAGE
} from "../store/mutations.names";
import axios from "axios";

import BannerTextBlock from "../components/BannerTextBlock.vue";
import BoardTeam from "@/components/BoardTeam.vue";
import BoardDetails from "@/components/BoardDetails.vue";
import InvestorContact from "@/components/InvestorContact.vue";
import FinancialStatement from "@/components/FinancialStatement.vue";
import PriceSensitiveInformation from "@/components/PriceSensitiveInformation.vue";
import Sharehold from "@/components/Sharehold.vue";
import FinancialProfile from "@/components/FinancialProfile.vue";
import LineChart from "@/components/LineChart.vue";
import AnnualSatement from "@/components/AnnualSatement.vue";
import FiveHighlights from "@/components/FiveHighlights.vue";
import AnnualReport from "@/components/AnnualReport.vue";
import CorporateGov from "@/components/CorporateGov.vue";
import AOS from "aos";
@Component({
    name: "InvestorPage",
    components: {
        banner: BannerTextBlock,
        board_of_directors: BoardTeam,
        quarterly_financial_statement: FinancialStatement,
        BoardDetails,
        financial_highlight: FinancialProfile,
        financial_common_tab_block: Sharehold,
        line_chart: LineChart,
        accordion_list_block: CorporateGov,
        annual_reports: AnnualReport,
        common_financial_report_block: AnnualSatement,
        investor_query_block: InvestorContact,
        price_sensitive_information: PriceSensitiveInformation
    }
})
export default class InvestorPage extends Vue {
    @Getter("investData") public investData!: InvestPageDataType[];
    @Prop() public pageData!: pageDataType;
    @Getter("pageType") public pageType!: string | null;
    @Action(FETCH_INVEST_DATA) public fetchData: any;
    @Mutation(SET_INVEST_CURRENT_PAGE) public[SET_INVEST_CURRENT_PAGE]: any;
    public HOST: string = HOST;

    isDropped: boolean = false;
    isActive: boolean = false;
    isHidden: boolean = true;
    activeTab: number = 0;
    activeSubTab: number | null = null;
    seen: boolean = false;
    public dropIt() {
        this.isDropped = !this.isDropped;
        this.isActive = !this.isActive;

        //this.isHidden = false;
    }

    get availableHashes() {
     //   console.log(this.pageData.body.length);
        let pageHashes: {
            [key: string]: any[]
        } = {};
        // if (this.pageData){
        // for (let tabIndex = 0; tabIndex < this.pageData.body.length; tabIndex++){
        //     // let item = this.pageData.body[tabIndex];
        //     console.log("blu")
        //     console.log(encodeURI(item.value.lebel.toLowerCase().replace(' ', '-')));
        //     // hashes[encodeURI(item.value.lebel.toLowerCase().replace(' ', '-'))] = tabIndex
        // }
        // }
        var d = this.pageData.body.map((tab: any, idx: number) => {
            let hash: string = (tab.value.label as string)
                .toLowerCase()
                .replace(/\s+/g, "-");
            pageHashes[hash] = [idx];
            if (tab.value.content[0].type === "tabbed_content") {
                tab.value.content[0].value.map((subTab: any, indx: number) => {
                    let subHash: string = `${hash}/${subTab.value.label
            .toLowerCase()
            .replace(/\s+/g, "-")}`;
                    pageHashes[subHash] = [idx, indx];
                });
            }
        });
        return pageHashes;
    }

    get currentContent() {
        //  console.log(this.pageData.body[this.activeTab].value.content[0].value);
        if (this.activeSubTab == null) {
            return this.pageData.body[this.activeTab].value.content[0].value;
        } else {
            return this.pageData.body[this.activeTab].value.content[0].value[
                this.activeSubTab
            ].value.content;
        }
    }

    tabFromHash(hashString: string) {
        hashString = hashString.substring(1, hashString.length);
        let hashData = (this as any).availableHashes[hashString];
        if (hashData) {
            if (hashData.length == 1) {
                this.setTab(hashData[0]);
            } else {
                (this as any).setTab(...hashData);
            }
        }
    }

    setTab(tab: number, subTab = NaN) {
        let st;
        if (isNaN(subTab)) {
            if (this.pageData.body[tab].value.content[0].type == "tabbed_content") {
                st = 0;
            } else {
                st = null;
            }
        } else {
            st = subTab;
        }
        // console.log(st);
        this.activeTab = tab;
        this.activeSubTab = st;
    }

    public hideMenu() {
        this.isDropped = false;
    }

    public created() {
        AOS.init();
    }
    public mounted() {
        this.fetchData(this.pageData.id);
        if (this.pageData.body.length > 0) {
            if (this.pageData.body[0].value.content[0].type == "tabbed_content") {
                this.activeSubTab = 0;
            }
        }
        if (window.location.hash.length > 1) {
            this.tabFromHash(window.location.hash);
        }
        AOS.init();
        // this.heroimganim();
        // this.smbanneranim();
        // console.log(this.jobData);
    }
}
